// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2KFwP","header":"Messages_header__3pClY"};